import { render, staticRenderFns } from "./technicians-detail-table-panel.vue?vue&type=template&id=c15c385c&scoped=true&lang=pug"
import script from "./technicians-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./technicians-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./technicians-detail-table-panel.vue?vue&type=style&index=0&id=c15c385c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15c385c",
  null
  
)

export default component.exports